/**
 * Notification bar
 */
 var cor_contact_lists = function() {

  var blocks = document.querySelectorAll('.js-contact-list');
  for (var i = 0; i < blocks.length; i++) {
    var block = blocks[i];
    var list = block.querySelector('.js-contact-list-loader');
    if (list) {
      var contact_list_id = list.getAttribute('data-contact-list-id');
      var card_type = list.getAttribute('data-card-type');
      if (contact_list_id) {
        var url = '/wp-json/wp/v2/cor-contact-list/' + contact_list_id + '/?card_type=' + card_type;
        axios.get(url)
        .then(function (response) {
            var body = response.data;
            console.log('[Dynamic contact list]', body.data);
            if (body.data && body.data.length > 0) {
              block.setAttribute('data-contact-count', body.data.length);
              var data = body.data;
              var html = '';
              for (var i = 0; i < data.length; i++) {
                html += data[i].html;
              }
              list.outerHTML = html;
            } else {
              console.log('[Contact list]: No data, removing HTML');
              var isLastBlock = block.classList.contains('is-last-block');
              block.remove();
              if (isLastBlock) {
                // add class to last child of .wysiwyg
                var wysiwyg = document.querySelector('.wysiwyg');
                if (wysiwyg) {
                  var lastChild = wysiwyg.lastElementChild;
                  lastChild.classList.add('is-last-block');
                }
              }
            }
        })
        .catch(function (error) {
          console.log(error);
        });

      }
    }
  }

};

window.addEventListener('load', function(event) {
  cor_contact_lists();
});
